import type { Client } from '../types';

export const clientsMock: Client[] = [
  {
    id: 'client-1',
    name: 'Constructora Alfa',
    taxId: 'CAL900101AB1',
    isActive: true,
    primaryContact: {
      id: 'contact-1',
      name: 'Juan Pérez',
      email: 'juan@alfa.com',
      phone: '+52 55 1234 5678',
    },
    createdAt: '2024-01-10T08:00:00Z',
  },
  {
    id: 'client-2',
    name: 'Distribuidora Beta',
    taxId: 'DBE850215CD2',
    isActive: true,
    primaryContact: {
      id: 'contact-2',
      name: 'María López',
      email: 'maria@beta.mx',
      phone: '+52 55 8765 4321',
    },
    createdAt: '2024-02-14T10:30:00Z',
  },
  {
    id: 'client-3',
    name: 'Servicios Gamma',
    taxId: 'SGA920730EF3',
    isActive: false,
    primaryContact: {
      id: 'contact-3',
      name: 'Carlos Ruiz',
      email: 'carlos@gamma.io',
      phone: null,
    },
    createdAt: '2024-03-05T09:00:00Z',
  },
  {
    id: 'client-4',
    name: 'Tecnologías Delta',
    taxId: 'TDE011120GH4',
    isActive: true,
    createdAt: '2024-04-22T14:00:00Z',
  },
  {
    id: 'client-5',
    name: 'Grupo Épsilon',
    taxId: 'GEP781010IJ5',
    isActive: false,
    primaryContact: {
      id: 'contact-5',
      name: 'Ana Torres',
      email: 'ana@epsilon.com',
      phone: '+52 55 1111 2222',
    },
    createdAt: '2024-05-18T11:45:00Z',
  },
];
